import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { getFormValues, getFormInitialValues } from "redux-form";

import { EDIT_VERSION_BLADE_FORM } from "forms/list";
import { isFrameAdjusted } from "utils/Refinements";
import useRefinedData from "hooks/useRefinedData";
import InlinePRVW from "./InlinePRVW";
import { API_URL } from "utils/constants";

import "./DisplayPreview.css";

export default function DisplayPreview({
	creative = {},
	libraryId = -1,
}) {
	const values = useSelector(getFormValues(EDIT_VERSION_BLADE_FORM)) || {}
		, initialValues = useSelector(getFormInitialValues(EDIT_VERSION_BLADE_FORM)) || {}
		, framesAdjusted = useMemo(() => isFrameAdjusted(values, initialValues), [values, initialValues]);

	const [creativeInfo, setCreativeInfo] = useState([{
		adType: creative.adType,
		height: creative.height,
		width: creative.width,
		numClickTags:creative.numClickTags,
		baseAsset: {
			host: API_URL,
			path: `/crm/v1/asset-manager/${libraryId}/${creative.id}/`,
			file: creative.routeFile ? `${creative.routeFile}?download=false` : "main.html?download=false",
		},
		version: {
			...creative.versionInfo,
		},
	}]);

	// Skip if frames are not adjusted
	const { isLoading, refinedDataMap } = useRefinedData(values, initialValues, libraryId, !framesAdjusted);

	useEffect(() => {
		if (!isLoading && refinedDataMap.size > 0) {
			for (let v in creative.versionInfo) {
				let variable = { ...creative.versionInfo[v] };
				const refinedData = refinedDataMap.get(v);

				if (variable.type === "Image") {
					// Update the variable with the refined data - ok to mutate as we set state later
					// after updating all variables
					variable.prop = refinedData.refinementDataUrl;
				} else if (variable.type === "Text") {
					variable.prop = refinedData.text;
				}

				creativeInfo[0].version[v] = variable;
			}	//end for(v in vreative.versionInfo)

			// Trigger a re-render
			setCreativeInfo([...creativeInfo]);
		}
	}, [isLoading, refinedDataMap]);

	return (
		<div className="inline-edit-preview">
			<InlinePRVW
				creativeProps={creativeInfo}
				libraryId={libraryId}
			/>
		</div>
	);
}
